import { useContactStore } from '~/store/contact';

export default defineNuxtRouteMiddleware(async (to, from) => {
  const { formSubmitted } = useContactStore();

  if (!formSubmitted) {
    return navigateTo('/contact');
  }
});
